/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mt_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipes inside cells are escaped automatically as \\| so they don't break the table, and line breaks within a cell are collapsed to spaces.`)
};

const es_mt_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las barras dentro de las celdas se escapan automáticamente como \\| para que no rompan la tabla, y los saltos de línea dentro de una celda se contraen a espacios.`)
};

const de_mt_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipes innerhalb von Zellen werden automatisch als \\| maskiert, damit sie die Tabelle nicht zerstören, und Zeilenumbrüche innerhalb einer Zelle werden zu Leerzeichen zusammengefasst.`)
};

const nl_mt_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pijpen in cellen worden automatisch ontsnapt als \\| zodat ze de tabel niet breken, en regelafbrekingen in een cel worden samengevouwen tot spaties.`)
};

const fr_mt_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les barres verticales à l'intérieur des cellules sont automatiquement échappées sous la forme \\| pour qu'elles ne cassent pas le tableau, et les sauts de ligne dans une cellule sont réduits à des espaces.`)
};

const it_mt_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le barre verticali dentro le celle sono automaticamente scappate come \\| in modo che non rompano la tabella, e le interruzioni di riga all'interno di una cella sono compresse in spazi.`)
};

const pt_br2_mt_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipes dentro de células são escapados automaticamente como \\| para que não quebrem a tabela, e quebras de linha dentro de uma célula são condensadas em espaços.`)
};

const pt_mt_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os pipes dentro das células são escapados automaticamente como \\| para que não quebrem a tabela, e as quebras de linha dentro de uma célula são reduzidas a espaços.`)
};

const ja_mt_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セル内のパイプは自動的に \\| としてエスケープされるため、テーブルが壊れず、セル内の改行はスペースに変換されます。`)
};

const zh_mt_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`单元格内的竖线会自动转义为 \\| ，以免破坏表格结构，单元格内的换行会被合并为空格。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mt_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mt_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mt_faq2_a", locale)
	if (locale === "en") return en_mt_faq2_a(inputs)
	if (locale === "es") return es_mt_faq2_a(inputs)
	if (locale === "de") return de_mt_faq2_a(inputs)
	if (locale === "nl") return nl_mt_faq2_a(inputs)
	if (locale === "fr") return fr_mt_faq2_a(inputs)
	if (locale === "it") return it_mt_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_mt_faq2_a(inputs)
	if (locale === "pt") return pt_mt_faq2_a(inputs)
	if (locale === "ja") return ja_mt_faq2_a(inputs)
	return zh_mt_faq2_a(inputs)
};